import Vue from 'vue';
import Router from 'vue-router';
// 引入store
import store from '@/store';

// 导入首页布局页面
const Home = () => import('@/components/Home');
// 导入首页
const HomePage = () => import('@/components/HomePage');
// 导入全职页面
const FullJob = () => import('@/components/FullJob');
// 导入实习页面
const FieldJob = () => import('@/components/FieldJob');
// 导入双选会页面
const DoubleElection = () => import('@/components/DoubleElection');
// 导入更多双选会页面
const MoreDoubleElection = () => import('@/components/MoreDoubleElection');
// 导入双选会详情页面
const DoubleElectionDetail = () => import('@/components/DoubleElectionDetail');
// 导入进入会场页面
const DoubleElectionContent = () => import('@/components/DoubleElectionContent');
// 导入咨询页面
const Consult = () => import('@/components/Consult');
// 导入咨询更多页面
const ConsultMore = () => import('@/components/ConsultMore');
// 导入咨询详情页面
const ConsultDetail = () => import('@/components/ConsultDetail');
// 导入个人中心菜单列表
const PersonalCenter = () => import('@/components/PersonalCenter');
// 导入个人中心-隐私设置
const HideSetting = () => import('@/components/HideSetting');
// 导入个人中心-设置打招呼语
const SetGreetings = () => import('@/components/SetGreetings');
// 导入个人中心-面试邀约
const OralInvite = () => import('@/components/OralInvite');
// 导入个人中心-修改密码
const UpdatePassword = () => import('@/components/UpdatePassword');
// 导入个人中心-修改手机号
const UpdatePhone = () => import('@/components/UpdatePhone');
// 导入个人中心-企业屏蔽
const ComShield = () => import('@/components/ComShield');
// 注销账号
const Logoff = () => import('@/components/logoff');
// 导入个人中心-我的宣讲会
const MyTeach = () => import('@/components/MyTeach');
// 导入个人中心-我的双选会
const MyElection = () => import('@/components/MyElection');
// 导入个人中心-我的信息
const MyInfo = () => import('@/components/MyInfo');
// 导入个人中心-我的简历
const MyNotes = () => import('@/components/MyNotes');
// 导入个人中心-预览简历
const PreviewNotes = () => import('@/components/PreviewNotes');
// 导入个人中心-投递记录
const DeliverRecords = () => import('@/components/DeliverRecords');
// 导入个人中心-邀请投递记录
const InviteRecords = () => import('@/components/InviteRecords');
// 导入个人中心-浏览记录
const LookRecords = () => import('@/components/LookRecords');
// 导入个人中心-附件简历
const FileNotes = () => import('@/components/FileNotes');
// 导入个人中心-收藏的职位
const CollectJob = () => import('@/components/CollectJob');
// 导入个人中心-收藏的公司
const CollectCompy = () => import('@/components/CollectCompy');
// 导入个人中心-收藏的双选会
const CollectElection = () => import('@/components/CollectElection');
// 导入完善信息三步走
const PerfectInfo = () => import('@/components/PerfectInfo');
// 导入公司详情页面
const CompyDetails = () => import('@/components/CompyDetails');
// 导入公司详情页面--简历待收集
const CompyDetailsResume = () => import('@/components/CompyDetailsResume');
// 导入宣讲会详情页面
const TeachDetails = () => import('@/components/TeachDetails');
// 导入实习 全职职位详情页面
const JobDetails = () => import('@/components/JobDetails');
// 导入实习 全职职位详情页面---简历待收集
const JobDetailsResume = () => import('@/components/JobDetailsResume');
// 导入微信扫码等待页面
const WaitPhone = () => import('@/components/WaitPhone');
// 导入绑定手机号页面
const BindPhone = () => import('@/components/BindPhone');
// 导入聊天模块
const MessageManage = () => import('@/components/MessageManage/MessageManage');
// 导入HR信息
const HrInfo = () => import('@/components/MessageManage/HrInfo');
// 导入消息通知
const Notify = () => import('@/components/MessageManage/Notify');
/**
 * @author lihh
 * @description 定义组件内导航守卫 
 */
let beforeEnter = (to, from, next) => {

  // 路由级别
  const grade = to.meta.grade;
  // 判断是否一级  还是二级  如果是1级可以随便走 但是如果是2级 需要路由加持
  if (grade === '2') {

      // 判断是否存在token
      let token = store.getters.token;
      !token || token === '' ? next({path: from.path}) : next();
  } else {

    next();
  }
}

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      redirect: '/homePage',
      name: 'home',
      component: Home,
      children: [
        // 首页
        {
          path: '/homePage',
          name: 'homePage',
          components: {displayPage: HomePage},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 全职职位
        {
          path: '/fullJob',
          name: 'fullJob',
          components: {displayPage: FullJob},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 实习职位
        {
          path: '/fieldJob',
          name: 'fieldJob',
          components: {displayPage: FieldJob},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 双选会首页
        {
          path: '/doubleElection',
          name: 'doubleElection',
          components: {displayPage: DoubleElection},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 更多双选会
        {
          path: '/moreDoubleElection',
          name: 'moreDoubleElection',
          components: {displayPage: MoreDoubleElection},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 双选会明细
        {
          path: '/doubleElectionDetail',
          name: 'doubleElectionDetail',
          components: {displayPage: DoubleElectionDetail},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 双选会会场
        {
          path: '/doubleElectionContent',
          name: 'doubleElectionContent',
          components: {displayPage: DoubleElectionContent},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 资讯
        {
          path: '/consult',
          name: 'consult',
          components: {displayPage: Consult},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 资讯明细
        {
          path: '/consultDetail',
          name: 'consultDetail',
          components: {displayPage: ConsultDetail},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 表示聊天
        {
          path: '/messageManage',
          name: 'messageManage',
          components: {displayPage: MessageManage},
          beforeEnter,
          meta: {
            'grade': '2'
          },
        },
        //查看HR信息
        {
          path: '/hrinfo/:id',
          name: 'HrInfo',
          components: {displayPage: HrInfo},
        },
         // 导入系统消息通知
         {
          path: '/notify',
          name: 'notify',
          components: {displayPage: Notify}
        },
        // 个人中心
        {
          path: '/personalCenter',
          name: 'personalCenter',
          redirect: '/myInfo',
          components: {displayPage: PersonalCenter},
          beforeEnter,
          meta: {
            'grade': '2'
          },
          children: [
            {
              path: '/SetGreetings',
              name: 'SetGreetings',
              components: {personalCenter: SetGreetings},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/hideSetting',
              name: 'hideSetting',
              components: {personalCenter: HideSetting},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/oralInvite',
              name: 'oralInvite',
              components: {personalCenter: OralInvite},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/updatePassword',
              name: 'updatePassword',
              components: {personalCenter: UpdatePassword},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/updatePhone',
              name: 'updatePhone',
              components: {personalCenter: UpdatePhone},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/ComShield',
              name: 'ComShield',
              components: {personalCenter: ComShield},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/Logoff',
              name: 'Logoff',
              components: {personalCenter: Logoff},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/myTeach',
              name: 'myTeach',
              components: {personalCenter: MyTeach},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/myElection',
              name: 'myElection',
              components: {personalCenter: MyElection},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/myInfo',
              name: 'myInfo',
              components: {personalCenter: MyInfo},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/myNotes',
              name: 'myNotes',
              components: {personalCenter: MyNotes},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/deliverRecords',
              name: 'deliverRecords',
              components: {personalCenter: DeliverRecords},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/inviteRecords',
              name: 'inviteRecords',
              components: {personalCenter: InviteRecords},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/lookRecords',
              name: 'lookRecords',
              components: {personalCenter: LookRecords},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/fileNotes',
              name: 'fileNotes',
              components: {personalCenter: FileNotes},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/collectJob',
              name: 'collectJob',
              components: {personalCenter: CollectJob},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/collectCompy',
              name: 'collectCompy',
              components: {personalCenter: CollectCompy},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/collectElection',
              name: 'collectElection',
              components: {personalCenter: CollectElection},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
            {
              path: '/previewNotes',
              name: 'previewNotes',
              components: {personalCenter: PreviewNotes},
              beforeEnter,
              meta: {
                'grade': '2'
              },
            },
          ]
        },
        // 注册三步走
        {
          path: '/perfectInfo',
          name: 'perfectInfo',
          components: {displayPage: PerfectInfo},
          beforeEnter,
          meta: {
            'grade': '2'
          },
        },
        // 企业详细信息
        {
          path: '/compyDetails',
          name: 'compyDetails',
          components: {displayPage: CompyDetails},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },

         // 企业详细信息--简历待收集
         {
          path: '/compyDetails_resume',
          name: 'compyDetailsResume',
          components: {displayPage: CompyDetailsResume},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 宣讲会详细
        {
          path: '/teachDetails',
          name: 'teachDetails',
          components: {displayPage: TeachDetails},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 职位详情
        {
          path: '/jobDetails',
          name: 'jobDetails',
          components: {displayPage: JobDetails},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },

         // 职位详情--简历待收集（复制）
         {
          path: '/jobDetails_resume',
          name: 'jobDetailsResume',
          components: {displayPage: JobDetailsResume},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 更多资讯
        {
          path: '/consultMore',
          name: 'consultMore',
          components: {displayPage: ConsultMore},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 手机等待
        {
          path: '/waitPhone',
          name: 'waitPhone',
          components: {displayPage: WaitPhone},
          beforeEnter,
          meta: {
            'grade': '1'
          },
        },
        // 绑定手机号
        {
          path: '/bindPhone',
          name: 'bindPhone',
          components: {displayPage: BindPhone},
          beforeEnter,
          meta: {
            'grade': '2'
          },
        }
      ],
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// 增加限制 避免路由重复报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js